// @flow
import { useContext } from 'react';

import { routerContext } from './routerContext';

export function useRouter<T: UrlParams, U: QueryParams>(): RouterContext<T, U> {
  // $FlowFixMe
  const router: RouterContext<T, U> = useContext(routerContext);
  return router;
}
